import { useCallback } from 'react';
import { analyticsTrackEvent } from '../../../core/analytics';
import { Actions, Events } from '../../Account/util/analytics';

export default (accountSummary: any, openDrawer: any) =>
  useCallback(() => {
    const numberOfProfiles = accountSummary.user_profiles && accountSummary.user_profiles.length;
    analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
      action: Actions.TOUCH_PRIMARY_TAB,
      label: 'Profile Selector',
      numberOfProfiles,
    });
    openDrawer();
  }, [openDrawer, accountSummary]);
